// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3UJb9","header":"PatientQuestionnaire_header__2xAmv","info":"PatientQuestionnaire_info__3704v"};